
import { BaseVue } from "@newview/base-web";
import { Component } from "vue-property-decorator";
@Component({
  name: "subSystem",
  components: {
  },
})
export default class subSystem extends BaseVue {
  subSystemList:any = []
  activeSubsys:any = {}
  roleList:any = []
  subsysteminforListAll = []
  activeRole:any = {}
  created(){
    let subProject:any = this.$globalData_Plms.itemInfo
    subProject.institutioninforList.forEach(element => {
      this.subsysteminforListAll = this.subsysteminforListAll.concat(element.subsysteminforList)
    });
    this.subSystemList = this.Baselinq.from(this.subsysteminforListAll).distinct(e=>e["id"]).toArray()
    this.activeSubsys = this.$globalData_Plms.subSysteminfor
    this.$emit("subSystemListOnSuccess",this.subSystemList,this.activeSubsys)
    this.activeRole = this.$globalData_Plms.subSysteminfor
    this.roleList = this.Baselinq.from(this.subsysteminforListAll).where(e=>e["RoleInfo"]["subSystemId"]==this.activeSubsys.id).toArray()
    if(this.isNull(localStorage.getItem("MainMenuDatas"))){
      this.changeRole(this.roleList[0].id,true)
    }
  }
  mounted() {
    
  }
  changeSubsystem(id){
    this.activeSubsys = this.Baselinq.from(this.subSystemList).firstOrDefault(e=>e["id"]==id)
    this.roleList = this.Baselinq.from(this.subsysteminforListAll).where(e=>e["RoleInfo"]["subSystemId"]==this.activeSubsys.id).toArray()
    this.changeRole(this.roleList[0].id,true)
  } 
  changeRole(id,ischange=false){
    if(this.roleList.length==1 && !ischange){
      return
    }
    let item:any = this.Baselinq.from(this.roleList).firstOrDefault(e=>e["id"]==id)
    this.activeRole = item
    let menuData = item.moduleinforList
    this.$globalData_Plms.roleInfo = item.RoleInfo
    this.$globalData_Plms.subSysteminfor = item
    localStorage.setItem('subSysteminfor', JSON.stringify(item))
    localStorage.setItem('roleInfo', JSON.stringify(item.RoleInfo))
    localStorage.setItem('activeMenu', '') //默认选中状态
    localStorage.setItem('openMenu', '') // 默认展开菜单
    localStorage.setItem("MainMenuDatas",JSON.stringify(this.loadMenuList(menuData)));
    sessionStorage.setItem('globalData_Plms', JSON.stringify(this.$globalData_Plms))
    this.$router.replace({ path: "/empty" });
    setTimeout(() => {
      this.$router.replace({ path: "/MainManage" });
    }, 50);
  }
  loadMenuList(datas) {
    const treeDatas: any = this.Baselinq.from(datas)
      .where((x) => x['pid'] == 0)
      .orderBy((p) => p['orderNo'])
      .toArray()
    for (let data of treeDatas) {
      data.children = this.loadMenuChild(data.id, datas)
    }
    return treeDatas
  }
  loadMenuChild(pid, datas) {
    const childDatas: any = this.Baselinq.from(datas)
      .where((x) => x['pid'] == pid)
      .orderBy((p) => p['orderNo'])
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        data.children = this.loadMenuChild(data.id, datas)
      }
    }
    return childDatas
  }
}
